import React from 'react';

export default function FlowFieldSpacer(props) {
    const { colClassName, field } = props;
    const { width } = field;

    return (
        <div className={`${colClassName}${width?.mobile == 0 ? ' d-none' : ''}${width?.tablet == 0 ? ' d-md-none' : ' d-md-block'}${width?.desktop == 0 ? ' d-lg-none' : ' d-lg-block'}`}></div>
    );
}
